import { render, staticRenderFns } from "./userCompanyEdit.vue?vue&type=template&id=88a81eac&"
import script from "./userCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./userCompanyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports